import { GENERATE_URL } from "@services/helpers/request";

const PREFIX_URL = "/Location";

export const LOCATION_PREFIX_URL = PREFIX_URL;

export const GetAll = (options) => GENERATE_URL(`${PREFIX_URL}`, options);

export const GetById = (options) => GENERATE_URL(`${PREFIX_URL}/:id`, options);

export const ParentLocationsWithCustomerCount = (options) =>
  GENERATE_URL(`${PREFIX_URL}/ParentLocationsWithCustomerCount`, options);

export const LocationsWithSaleCount = (options) =>
  GENERATE_URL(`${PREFIX_URL}/LocationsWithSaleCount`, options);

export const LocationsWithPlanCount = (options) =>
  GENERATE_URL(`${PREFIX_URL}/LocationsWithPlanCount`, options);

export const LocationsWithProductSaleCount = (options) =>
  GENERATE_URL(`${PREFIX_URL}/LocationsWithProductSaleCount`, options);

export const LocationsWithCategorySaleCount = (options) =>
  GENERATE_URL(`${PREFIX_URL}/LocationsWithCategorySaleCount`, options);

export const ProductSalesWithLocation = (options) =>
  GENERATE_URL(`${PREFIX_URL}/ProductSalesWithLocation`, options);

export const ProductCategorySalesWithLocation = (options) =>
  GENERATE_URL(`${PREFIX_URL}/ProductCategorySalesWithLocation`, options);

export const RegionsWithEmployees = (options) =>
  GENERATE_URL(`${PREFIX_URL}/RegionsWithEmployees`, options);

export default {
  GetAll,
  GetById,
  ParentLocationsWithCustomerCount,
  LocationsWithSaleCount,
  LocationsWithPlanCount,
  LocationsWithProductSaleCount,
  LocationsWithCategorySaleCount,
  ProductSalesWithLocation,
  ProductCategorySalesWithLocation,
  RegionsWithEmployees,
};
